export const authConstants = {
  KEY_GENERATION_REQUEST: "KEY_GENERATION_REQUEST",
  KEY_GENERATION_COMPLETE: "KEY_GENERATION_COMPLETE",
  KEY_REGENERATION: "KEY_REGENERATION",

  AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
  AUTH_LOGIN_COMPLETE: "AUTH_LOGIN_COMPLETE",

  AUTH_LOGIN_FEBA_USER_NAME_STORE: "AUTH_LOGIN_FEBA_USER_NAME_STORE",

  AUTH_LOGOUT_REQUEST: "AUTH_LOGOUT_REQUEST",
  AUTH_LOGOUT_COMPLETE: "AUTH_LOGOUT_COMPLETE",

  IDLE_TIMEOUT_LOGOUT_REQUEST: "IDLE_TIMEOUT_LOGOUT_REQUEST",
  IDLE_TIMEOUT_COMPLETE: "IDLE_TIMEOUT_COMPLETE",

  OTP_CONFIRM_REQUEST: "OTP_CONFIRM_REQUEST",
  OTP_CONFIRM_COMPLETE: "OTP_CONFIRM_COMPLETE",

  OTP_RESEND_REQUEST: "OTP_RESEND_REQUEST",
  OTP_RESEND_COMPLETE: "OTP_RESEND_COMPLETE",

  AUTH_REDUCER_INITIATE: "AUTH_REDUCER_INITIATE",

  AUTH_PASSWORD_RESET_STATUS: "AUTH_PASSWORD_RESET_STATUS",

  EXPIRED_PASSWORD_CHANGE_VALUE_REQUEST:
    "EXPIRED_PASSWORD_CHANGE_VALUE_REQUEST",
  EXPIRED_PASSWORD_CHANGE_VALUE_COMPLETE:
    "EXPIRED_PASSWORD_CHANGE_VALUE_COMPLETE",
  EXPIRED_PASSWORD_CHANGE_VALUE_ERROR: "EXPIRED_PASSWORD_CHANGE_VALUE_ERROR",

  AUTH_CLEAR_STORE: "AUTH_CLEAR_STORE",

  VALUE_Y: "Y",
  SET_REFRESH_FLAG: "SET_REFRESH_FLAG",

  FORGOT_USERNAME_VALIDATE_REQUEST: "FORGOT_USERNAME_VALIDATE_REQUEST",
  FORGOT_USERNAME_VALIDATE_COMPLETE: "FORGOT_USERNAME_VALIDATE_COMPLETE",
  FORGOT_USERNAME_VALIDATE_ERROR: "FORGOT_USERNAME_VALIDATE_ERROR",

  FORGOT_USERNAME_OTP_CONFIRM_REQUEST: "FORGOT_USERNAME_OTP_CONFIRM_REQUEST",
  FORGOT_USERNAME_OTP_CONFIRM_COMPLETE: "FORGOT_USERNAME_OTP_CONFIRM_COMPLETE",
  FORGOT_USERNAME_OTP_CONFIRM_ERROR: "FORGOT_USERNAME_OTP_CONFIRM_ERROR",

  FORGOT_USERNAME_OTP_RESEND_REQUEST: "FORGOT_USERNAME_OTP_RESEND_REQUEST",
  FORGOT_USERNAME_OTP_RESEND_COMPLETE: "FORGOT_USERNAME_OTP_RESEND_COMPLETE",
  FORGOT_USERNAME_OTP_RESEND_ERROR: "FORGOT_USERNAME_OTP_RESEND_ERROR",

  CSRF_TOKEN_GEN_REQUEST: "CSRF_TOKEN_GEN_REQUEST",
  CSRF_TOKEN_GEN_COMPLETE: "CSRF_TOKEN_GEN_COMPLETE",
  CSRF_TOKEN_GEN_ERROR: "CSRF_TOKEN_GEN_ERROR",

  CHANGE_LANGUAGE_REQUEST: "CHANGE_LANGUAGE_REQUEST",
  CHANGE_LANGUAGE_COMPLETE: "CHANGE_LANGUAGE_COMPLETE",
  CHANGE_LANGUAGE_SUCCESS_ALERT_HIDE: "CHANGE_LANGUAGE_SUCCESS_ALERT_HIDE",
  CHANGE_LANGUAGE_SUCCESS_ALERT_SHOW: "CHANGE_LANGUAGE_SUCCESS_ALERT_SHOW",

  FORGOT_PASSWORD_VALIDATE_REQUEST: "FORGOT_PASSWORD_VALIDATE_REQUEST",
  FORGOT_PASSWORD_VALIDATE_COMPLETE: "FORGOT_PASSWORD_VALIDATE_COMPLETE",
  FORGOT_PASSWORD_VALIDATE_ERROR: "FORGOT_PASSWORD_VALIDATE_ERROR",

  FORGOT_PASSWORD_OTP_CONFIRM_REQUEST: "FORGOT_PASSWORD_OTP_CONFIRM_REQUEST",
  FORGOT_PASSWORD_OTP_CONFIRM_COMPLETE: "FORGOT_PASSWORD_OTP_CONFIRM_COMPLETE",
  FORGOT_PASSWORD_OTP_CONFIRM_ERROR: "FORGOT_USERNAME_OTP_CONFIRM_ERROR",

  FORGOT_PASSWORD_OTP_RESEND_REQUEST: "FORGOT_PASSWORD_OTP_RESEND_REQUEST",
  FORGOT_PASSWORD_OTP_RESEND_COMPLETE: "FORGOT_PASSWORD_OTP_RESEND_COMPLETE",
  FORGOT_PASSWORD_OTP_RESEND_ERROR: "FORGOT_PASSWORD_OTP_RESEND_ERROR",

  SET_ADMIN_PASSWORD_RESET_REQUIRED: "SET_ADMIN_PASSWORD_RESET_REQUIRED",

  FORGOT_PASSWORD_ACCOUNT_CONFIRM_REQUEST:
    "FORGOT_PASSWORD_ACCOUNT_CONFIRM_REQUEST",
  FORGOT_PASSWORD_ACCOUNT_CONFIRM_COMPLETE:
    "FORGOT_PASSWORD_ACCOUNT_CONFIRM_COMPLETE",
  FORGOT_PASSWORD_ACCOUNT_CONFIRM_ERROR:
    "FORGOT_PASSWORD_ACCOUNT_CONFIRM_ERROR",

  FORGOT_PASSWORD_CHANGE_VALUE_REQUEST: "FORGOT_PASSWORD_CHANGE_VALUE_REQUEST",
  FORGOT_PASSWORD_CHANGE_VALUE_COMPLETE:
    "FORGOT_PASSWORD_CHANGE_VALUE_COMPLETE",
  FORGOT_PASSWORD_CHANGE_VALUE_ERROR: "FORGOT_PASSWORD_CHANGE_VALUE_ERROR",

  REGISTRED_TYPE_CREDIT_CARD: "CREDIT_CARD",
  REGISTRED_TYPE_DEBIT_CARD: "DEBIT_CARD",

  SET_ADMIN_PASSWORD_RESET_STATUS: "SET_ADMIN_PASSWORD_RESET_STATUS",

  ADMIN_PASSWORD_RESET_SCREEN: "ADMIN_PASSWORD_RESET_SCREEN",
  ADMIN_PASSWORD_SUCCESS_SCREEN: "ADMIN_PASSWORD_SUCCESS_SCREEN",

  SET_FORGOT_PASSWORD_SCREEN_TYPE: "SET_FORGOT_PASSWORD_SCREEN_TYPE",

  RESET_OTP_CONFIRM_STATE: "RESET_OTP_CONFIRM_STATE",

  SET_FORGOT_PASSWORD_FORM_DATA: "SET_FORGOT_PASSWORD_FORM_DATA",

  SET_CARD_TAB_SCREEN: "SET_CARD_TAB_SCREEN",

  CASA_ACCOUNT_TYPE: "CASA",

  CLEAR_FORGOT_PASSWORD_DETAILS: "CLEAR_FORGOT_PASSWORD_DETAILS",

  SET_FORGOT_USERNAME_MESSAGE: "SET_FORGOT_USERNAME_MESSAGE",
  IS_PAGE_ACTIVE: "isPageActive",
  SESSION_ACTIVE: "authSessionActive",

  SET_MULTIPLE_TAB_OPEN: "SET_MULTIPLE_TAB_OPEN",
};

export const cookieConstants = {
  USER_DETAILS_COOKIE: "user",
  FIRST_TIME_LOGIN: "ib-user",
  IS_ACCOUNTS_SYNC: "is-sync-account",
};
